function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component, useMemo } from 'react';
import { computeGridLines } from '../lib/compute';

class Grid extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderGridX", () => {
      const _this$props = this.props,
            width = _this$props.width,
            height = _this$props.height,
            xScale = _this$props.xScale,
            yScale = _this$props.yScale,
            xValues = _this$props.xValues,
            yValues = _this$props.yValues;

      if (!xScale) {
        return false;
      }

      const xLines = computeGridLines({
        width,
        height,
        scale: xScale,
        axis: 'x',
        values: xValues
      });
      return xLines.map(this.renderLineX);
    });

    _defineProperty(this, "renderGridY", () => {
      const _this$props2 = this.props,
            width = _this$props2.width,
            height = _this$props2.height,
            xScale = _this$props2.xScale,
            yScale = _this$props2.yScale,
            xValues = _this$props2.xValues,
            yValues = _this$props2.yValues;

      if (!yScale) {
        return false;
      }

      const yLines = computeGridLines({
        width,
        height,
        scale: yScale,
        axis: 'y',
        values: yValues
      });
      return yLines.map(this.renderLineY);
    });

    _defineProperty(this, "renderLineX", (line, index) => {
      return React.createElement("line", _extends({}, line, {
        key: index,
        className: "gridline  gridline--x"
      }));
    });

    _defineProperty(this, "renderLineY", (line, index) => {
      return React.createElement("line", _extends({}, line, {
        key: index,
        className: "gridline  gridline--y"
      }));
    });
  }

  render() {
    return React.createElement("g", {
      className: "grid"
    }, this.renderGridX(), this.renderGridY());
  }

}

export default Grid;